import * as React from "react"
import { Typography } from "@mui/material"


export default function percentageColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value) => <Typography variant="body2" sx={{ mr: 2, textAlign: 'right' }}>
				{value + '%'}
			</Typography>
		}
	}
}